// extracted by mini-css-extract-plugin
export default {"root":"DatePicker_root__D+nki","dataPicker":"DatePicker_dataPicker__zlZZX","icon":"DatePicker_icon__q+mc1","clearTo":"DatePicker_clearTo__ykIpI"};